import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { instantAccessItems } from '../data/instantAccess';
import { Reveal } from './Reveal';
export function InstantAccessSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-84" data-mp="1mf2ctd0ek2u7">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-85" data-mp="1mgna3ae3pzvr">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-coral/15 text-brand-coral" data-id="element-86" data-mp="1hnalv1dc3v3j">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-87" data-mp="1wf2zn8xhd135" />
        </div>
        <h2 className="mb-12 text-3xl font-black uppercase tracking-tight text-brand-navy md:text-4xl" data-id="element-88" data-mp="1rddn1oum0fcy">
          ⚡ Co otrzymujesz od razu?
        </h2>
        <div className="space-y-3 text-left" data-id="element-89" data-mp="20etnp4vmh33z">
          {instantAccessItems.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-dark bg-brand-alt p-5 shadow-sm" data-id="element-90" data-mp="azdpuln5f3te">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-coral" aria-hidden="true" data-id="element-91" data-mp="62nbq3uwmiam" />
              <span className="font-semibold" data-id="element-92" data-mp="2mzkf4i2aih5y">{item}</span>
            </div>)}
        </div>
        <p className="mt-10 font-display text-2xl font-black italic text-brand-coral" data-id="element-93" data-mp="2rynmi95qszh3">
          Nigdy nie zabraknie Ci materiału.
        </p>
      </Reveal>
    </section>;
}